export const ROUTES = {
    HOME: '/',
    MINING_AND_PUMPING: '/mining-and-pumping',
    SUMMARY_MODE: '/mining-and-pumping/summary-mode',
    WELL_LOGGING_OPERATIONS: '/well-logging-operations',
    TECHNOLOGICAL_EFFICIENCY_GTM: '/technological-efficiency-gtm',
    MAP_GENERATION: '/map-generation',
    MAP_WASM: '/wasm/map',
    LOGIN: '/login',
    DESATURATION_CHARACTERISTICS: '/desaturation-characteristics',
    OIL_PRODUCTION_LOSS: '/oil-production-loss',
    FACTOR_ANALYSIS: '/factor-analysis',
    GSR: '/gsr',
    WELLS_VIEW: '/wells-view',
    REPORTS: '/reports',
    URZM: '/urzm',
    GEOTEST: '/geotest',
};
